var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16,3c-0.6,0.3-1.2,0.4-1.9,0.5c0.7-0.4,1.2-1.1,1.4-1.8c-0.6,0.4-1.3,0.7-2.1,0.8c-0.6-0.7-1.5-1-2.4-1\n\tC9.3,1.5,7.8,3,7.8,4.8c0,0.3,0,0.5,0.1,0.7C5.2,5.4,2.8,4.1,1.1,2.1C0.8,2.6,0.7,3.2,0.7,3.7c0,1.1,0.5,2.1,1.5,2.7\n\tc-0.5,0-1-0.2-1.5-0.4v0c0,1.6,1.1,2.9,2.6,3.2c-0.5,0.1-1,0.2-1.5,0.1c0.4,1.3,1.7,2.3,3.1,2.3C3.5,12.7,1.7,13.2,0,13\n\tc1.5,1,3.2,1.5,5,1.5c6,0,9.3-5,9.3-9.3c0-0.1,0-0.3,0-0.4C15,4.3,15.6,3.7,16,3L16,3z","fill":"currentColor"}));
}

Twitter.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Twitter;

Twitter.default = Twitter;
